import 'lenis/dist/lenis.css'
import './css/pivot.scss'
import './js/pivot.js'